import Client from "./_client";

export const createCaseMasterAttempt = async (data) => {
  let url = "/casemasterAttempt";

  const result = await new Client({
    path: url,
    payload: data
  }).post();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to create attempt. Please try again."
    );
  }

  return result?.data;
};

export const startCaseMasterAttempt = async (attemptId, data) => {
  let url = `/casemasterAttempt/${attemptId}/start`;

  const result = await new Client({
    path: url,
    payload: data
  }).post();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to start attempt. Please try again."
    );
  }

  return result?.data;
};

export const getRecentCaseMasterAttempts = async (filters) => {
  let url = "/caseMasterAttempt/recent?";

  Object.keys(filters).forEach((key) => {
    if (filters[key] !== undefined) url += `${key}=${filters[key]}&`;
  });

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get attempts. Please try again."
    );
  }

  // `total` is only returned when includeTotal is requested.
  return {
    attempts: result?.data?.casemasterAttempts || [],
    total: result?.data?.total || 0
  };
};

export const getCaseMasterAttempts = async (filters) => {
  let url = "/caseMasterAttempt?";

  Object.keys(filters).forEach((key) => {
    if (filters[key] !== undefined) url += `${key}=${filters[key]}&`;
  });

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get attempts. Please try again."
    );
  }
  return result?.data;
};

export const getCaseMasterAttemptById = async (id) => {
  let url = "/caseMasterAttempt/" + id;

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get attempt. Please try again."
    );
  }

  return result?.data;
};

export const getCaseMasterImprovements = async (id) => {
  let url = `/caseMasterAttempt/${id}/improvements`;

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get improvement pointers. Please try again."
    );
  }

  return result?.data?.improvements || [];
};

export const generateCaseMasterFeedback = async (id) => {
  let url = `/caseMasterAttempt/${id}/generate-feedback`;

  const result = await new Client({
    path: url,
  }).post();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to generate feedback. Please try again."
    );
  }

  return result?.data;
};

export const getCaseMasterFeedbackByToken = async (accessToken) => {
  let url = `/casemasterAttempt/public/token?at=${accessToken}`;
  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get feedback. Please try again."
    );
  }

  return result?.data;
};

export const finishCaseMasterAttempt = async (id, data) => {
  let url = `/casemasterAttempt/${id}/finish`;

  const result = await new Client({
    path: url,
    payload: data
  }).post();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to finish attempt. Please try again."
    );
  }

  return result?.data;
};

